<template>
  <div class="quality-header">
    <a :href="urlLanguagePrefix + '/'" class="quality-header__image">
      <img src="/img/svgo/checkout/dniprom-logo.svg" alt="dnipro-m-logo">
    </a>
    <ul class="quality-header__list">
      <li class="quality-header__list-item">
        {{ $t('header_text_1') }}
      </li>
      <li class="quality-header__list-item">
        {{ $t('header_text_2') }}
      </li>
      <li class="quality-header__list-item">
        {{ $t('header_text_3') }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  computed: {
    ...mapGetters(['urlLanguagePrefix'])
  }
}
</script>

<style lang="sass" scoped>

.quality-header
  display: flex
  flex-direction: column
  align-items: center
  padding: 20px 0

.quality-header__image
  margin-bottom: 30px

.quality-header__list
  +list-unstyled
  display: flex
  flex-direction: row

.quality-header__list-item
  display: flex
  flex-direction: row
  align-items: center
  text-transform: uppercase
  font-weight: 500
  font-size: 16px
  line-height: 20px
  text-align: center
  letter-spacing: 0.1em

  &:not(:last-child)
    &:after
      content: ''
      display: block
      width: 3px
      height: 3px
      border-radius: 50%
      background-color: $text-color
      opacity: 0.2
      margin: 0 10px

</style>
